import React from 'react';
import './main.less';
import PropTypes from 'prop-types';
import _intersection from 'lodash/intersection';
import ModalBox from '../../../../../shared/modal';

const DeleteLandingModal = ({data, id, intl, remove, close, setActivePromoId, activePromoId }) => {
	const item = data.filter(item => item.id === id)[0];
	const landingsToSwitch = data
		.filter(i => i.id !== id)
		.filter(i => !!_intersection(item.languages, i.languages).length)
		.filter(i => {
			return !i.metadata || (
				i.metadata.relevance_for_last_6_months !== false &&
				i.metadata.relevance_for_last_12_months !== false
			);
		});

	const submit = (data) => {
		remove(id, data);
		close(null);
	};
	return (
		<ModalBox
			className='modal-overlay__content affiliate-registration-modal'
			body={
				<div className="delete-modal">
					{landingsToSwitch.length !== 0 &&
					<div>
						<h4>{`${intl('Choose the domain to redirect traffic from')} ${item.domain}`}</h4>
					</div>}
					{landingsToSwitch.map((item, index) => (
						<div
							className='delete_landing-modal__item-wrapper'
							key={index}
						>
							<div
								className={`delete_landing-modal__item ${item.id === activePromoId ? 'active' : ''}`}
								onClick={() => setActivePromoId(item.id === activePromoId ? null : item.id)}
							>
								{item.domain}
							</div>
							<a
								className='view-icon'
								onClick={() => {
									if (item.domain) {
										window.open('http://' + item.domain, '_blank');
									}
								}}
							/>
						</div>
					))}
					{landingsToSwitch.length === 0 &&
						<div
						>
							<b>{intl(`You can't delete the last domain with languages: `)}</b>
							<b>{item.languages.join(', ')}</b>
						</div>}
					<div className="delete_landing-modal__button">
						<button
							onClick={() => submit(activePromoId)}
							disabled={!activePromoId}
							className="ui-btn ui-btn-primary margin-0-10"
						>
							{intl('Ok')}
						</button>
						<button onClick={() => close(null)} className="ui-btn ui-btn-cancel cancel-btn">
							{intl('Cancel')}
						</button>
					</div>
					{item.type === 'transit' && (
						<div className="delete_landing-modal__button">
							<b>{intl('OR')}</b>
						</div>
					)}
					{item.type === 'transit' && (
						<div className="delete_landing-modal__button">
							<button
								onClick={() => submit(null)}
								className="ui-btn ui-btn-primary margin-0-10"
							>
								{intl('Delete without traffic redirection')}
							</button>
						</div>
					)}
				</div>
			}
			onClose={close}
			isOpen={true}
		/>
	);
};

class DeleteLandingModalContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = { activePromoId: null };
		this.setActivePromoId = this.setActivePromoId.bind(this);
	}
	setActivePromoId(id) {
		this.setState({ activePromoId: id });
	}
	render() {
		return <DeleteLandingModal
			{...this.props}
			activePromoId={this.state.activePromoId}
			setActivePromoId={this.setActivePromoId}
		/>;
	}
}

DeleteLandingModalContainer.propTypes = {
	remove: PropTypes.func,
	close: PropTypes.func,
	intl: PropTypes.func,
	id: PropTypes.number,
	data: PropTypes.array
};

export default DeleteLandingModalContainer;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/forms/landings/delete-modal/main.js